export let getVersion = (version) => {

    let regex = /(\d{1,})\.(\d{1,})\.(\d{1,})/;
    let result = regex.exec(version);
    if (result) {
        let major = Number(result[1]);
        let minor = Number(result[2]);
        let patch = Number(result[3]);

        return { major, minor, patch };
    }
}

/**
 * Compare string-based (1.5.345) versions. Returns -1 if A is earlier than B.
 */
export let compareVersions = (versionA, versionB) => {
    let _versionA = getVersion(versionA);
    let _versionB = getVersion(versionB);

    if (_versionA.major < _versionB.major) {
        return -1;
    }
    if (_versionA.major > _versionB.major) {
        return 1;
    }

    if (_versionA.minor < _versionB.minor) {
        return -1;
    }
    if (_versionA.minor > _versionB.minor) {
        return 1;
    }

    if (_versionA.patch < _versionB.patch) {
        return -1;
    }
    if (_versionA.patch > _versionB.patch) {
        return 1;
    }
}